module.exports = __webpack_public_path__ + "static/media/promotion_under_30.744e81f9.webp";